import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { formatAsDollarsWithoutZeroCents } from 'common/source/utilities/strings';
import { openUrlInNewTab } from 'common/source/utilities/windowHelper';
import { ITimeoutService } from 'angular';
import { HippoApiService } from 'services/hippoApi';
import { getSortedPastPaidPayments } from 'common/source/utilities/policyInfoHelper';

const module = angular.module('past-payments-section', []);

interface PastPaymentsSectionController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    pastPayments: Array<PastCharge>;
    downloadReceipt: (payment: Payment) => void;
    formatAsDollarsWithoutZeroCents: (sum: number) => string;
}

module.component('pastPaymentsSection', {
    bindings: {
        policyInfo: '<'
    },
    template: template,
    controller: function(
        this: PastPaymentsSectionController,
        $element: angular.IAugmentedJQuery,
        $timeout: ITimeoutService,
        hippoApiService: HippoApiService
    ) {
        const updateDisplay = () => {
            this.pastPayments = getSortedPastPaidPayments(this.policyInfo);

            if (this.pastPayments.length === 0) {
                $element.addClass('ng-hide');
            }
        };

        this.$onInit = () => {
            updateDisplay();
        };

        this.formatAsDollarsWithoutZeroCents = (sum: number) => {
            return formatAsDollarsWithoutZeroCents(sum);
        };

        this.$onChanges = (changesObj) => {
            const policyInfo = changesObj.policyInfo;
            if (policyInfo && policyInfo.currentValue !== undefined) {
                $timeout(() => {
                    this.policyInfo = policyInfo.currentValue;
                    updateDisplay();
                });
            }
        };

        this.downloadReceipt = (payment: Payment) => {
            const policyId = this.policyInfo.id;
            hippoApiService.createInvoice(policyId, payment).then((result) => {
                openUrlInNewTab(result.data.url);
            });
        };
    }
});

export { module };
